var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Spinner from '../common/Spinner/Spinner';
import APLogo from '../common/APLogo/APLogo';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import path from '../../helpers/path';
import { defaultPath } from '../../routeTemplates';
import '../../styles/components/common/StandaloneModal.css';
var baseClasses = getBEMClasses('standalone-modal');
var ConfirmWithdrawComponent = function (_React$Component) {
  _inherits(ConfirmWithdrawComponent, _React$Component);
  function ConfirmWithdrawComponent() {
    _classCallCheck(this, ConfirmWithdrawComponent);
    return _possibleConstructorReturn(this, (ConfirmWithdrawComponent.__proto__ || Object.getPrototypeOf(ConfirmWithdrawComponent)).apply(this, arguments));
  }
  _createClass(ConfirmWithdrawComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.fetchConfirmWithdraw();
    }
  }, {
    key: 'render',
    value: function render() {
      var context = this.context,
        _props = this.props,
        processingConfirmWithdraw = _props.processingConfirmWithdraw,
        message = _props.message;
      return React.createElement('div', {
        className: '' + baseClasses('wrapper')
      }, React.createElement(APLogo, {
        customClass: baseClasses('logo'),
        linkTo: '/'
      }), React.createElement('div', {
        className: '' + baseClasses('container')
      }, React.createElement('div', {
        className: '' + baseClasses('body')
      }, React.createElement('div', {
        className: '' + baseClasses('body-text')
      }, context.t(message))), message && React.createElement(React.Fragment, null, React.createElement('div', {
        className: '' + baseClasses('footer')
      }, React.createElement(Link, {
        to: path('' + defaultPath.path),
        className: baseClasses('btn', 'additive')
      }, context.t('Go to Exchange')))), React.createElement(Spinner, {
        isVisible: processingConfirmWithdraw,
        text: 'Confirming your withdrawal'
      })));
    }
  }]);
  return ConfirmWithdrawComponent;
}(React.Component);
ConfirmWithdrawComponent.defaultProps = {
  fetchConfirmWithdraw: function fetchConfirmWithdraw() {},
  processingConfirmWithdraw: true,
  message: ''
};
ConfirmWithdrawComponent.propTypes = {
  fetchConfirmWithdraw: PropTypes.func.isRequired,
  processingConfirmWithdraw: PropTypes.bool.isRequired,
  message: PropTypes.string
};
ConfirmWithdrawComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default ConfirmWithdrawComponent;